import { combineReducers } from 'redux';

import userList from './userList/reducer';
import userEdit from './userEdit/reducer';

export default combineReducers({
  userList,
  userEdit,
});
